/** Copyright (c) 2019 T.Rowe Price. All rights reserved. */

import './VerificationInformation.scss';

import noop from 'lodash/noop';
import isEmpty from 'lodash/isEmpty';
import { object, func } from 'prop-types';
import React, { Fragment } from 'react';

import CustomerName from './CustomerName';
import EmailAddresses from './EmailAddresses';
import MailingAddresses, { ResidentialAddress } from './MailingAddresses';
import Optioner from 'components/shared/Optioner/Optioner';
import PhoneNumbers from './PhoneNumbers';
import { residentialAddressEnabled } from 'services/FeatureFlags';

const CUSTOMER = 'customer';
const MAILING_ADDRESSES = 'mailingAddresses';
const RESIDENTIAL_ADDRESSES = 'residentialAddresses';
const EMAIL_ADDRESSES = 'emailAddresses';
const PHONE_NUMBERS = 'phoneNumbers';
const verificationInformationOrder = [
  CUSTOMER,
  RESIDENTIAL_ADDRESSES,
  MAILING_ADDRESSES,
  EMAIL_ADDRESSES,
  PHONE_NUMBERS
];

const VerificationInformation = ({
  contactMethodMaintenanceFiltered,
  customer,
  errors,
  onClose
}) => {
  const CMMInformation = {
    ...contactMethodMaintenanceFiltered,
    customer: customer
  };

  //We have decided to let the service indicate if addresses are the same.
  //The service will only return residential addresses if it is different from the primaryMailing address
  const sameAsResidential = residentialAddressEnabled() && contactMethodMaintenanceFiltered && isEmpty(contactMethodMaintenanceFiltered.residentialAddresses);

  return (
    <div className="cmm-modal-content">
      <p className="cmm-modal-info">
        To ensure optimal servicing for your account(s), please verify that the
        following information is up to date.
      </p>
      <div className="cmm-modal-content-fields-container">
        <div className="cmm-modal-content-fields">
          {verificationInformationOrder.map((key) => {
            const data = CMMInformation[key] || [];
            return (
              <Fragment key={key}>
                <Optioner val={key}>
                  {{
                    customer: <CustomerName customer={data} />,
                    mailingAddresses: (
                      <MailingAddresses
                        sameAsResidential={sameAsResidential}
                        address={data}
                        errors={errors}
                      />
                    ),
                    residentialAddresses: (
                      <ResidentialAddress address={data} />
                    ),
                    emailAddresses: (
                      <EmailAddresses emailAddresses={data} errors={errors} />
                    ),
                    phoneNumbers: (
                      <PhoneNumbers phoneNumbers={data} onClick={onClose} />
                    )
                  }}
                </Optioner>
              </Fragment>
            );
          })}
        </div>
      </div>
    </div>
  );
};

VerificationInformation.propTypes = {
  contactMethodMaintenanceFiltered: object,
  customer: object,
  errors: object,
  onClose: func
};

VerificationInformation.defaultProps = {
  contactMethodMaintenanceFiltered: {},
  customer: {},
  errors: {},
  onClose: noop
};

export default VerificationInformation;
